import { getAsync } from "utils/net";

export let settings: any;

export const loadSettings = () => getAsync("/api/designer/getclientsettings")
    .then(reply => reply.json())
    .then(val => settings = val);


// WEBPACK FOOTER //
// ./src/settings.ts